module.exports = __webpack_public_path__ + "static/media/FM_ASIC_Terms_Conditions_January_2025.a6c3c59c.pdf";